// extracted by mini-css-extract-plugin
module.exports = {"blur":"Transitions_blur__16LvN","slide":"Transitions_slide__3vq-Z"};